import {
  GET_CARPARKS,
  GET_CARPARK_FAIL,
  GET_CARPARKS_SUCCESS,
  GET_CARPARK_DETAIL,
  ADD_NEW_CARPARK,
  ADD_CARPARK_SUCCESS,
  ADD_CARPARK_FAIL,
  UPDATE_CARPARK,
  UPDATE_CARPARK_SUCCESS,
  UPDATE_CARPARK_FAIL,
  GET_CARPARK_DETAIL_FAIL,
  GET_CARPARK_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_CARPARK,
  DELETE_CARPARK_SUCCESS,
  DELETE_CARPARK_FAIL,
  GET_CARPARK_OCCUPANCY_RATE,
  GET_CARPARK_OCCUPANCY_RATE_FAIL,
  GET_CARPARK_OCCUPANCY_RATE_SUCCESS,  
  GET_EXPORT_OCCUPANCY_RATE,
  GET_EXPORT_OCCUPANCY_RATE_SUCCESS,
  GET_EXPORTED_OCCUPANCY_RATE_FAIL,
  RESET_EXPORT_DATA,
} from "./actionTypes"

export const getCarParks = payload => ({
  type: GET_CARPARKS,
  payload,
})

export const getCarParksSuccess = CarParks => ({
  type: GET_CARPARKS_SUCCESS,
  payload: CarParks,
})

export const getCarParksFail = error => ({
  type: GET_CARPARK_FAIL,
  payload: error,
})

export const getOccupancyRate = payload => ({
  type: GET_CARPARK_OCCUPANCY_RATE,
  payload,
})

export const getOccupancyRateSuccess = OccupancyRate => ({
  type: GET_CARPARK_OCCUPANCY_RATE_SUCCESS,
  payload: OccupancyRate,
})

export const getOccupancyRateFail = error => ({
  type: GET_CARPARK_OCCUPANCY_RATE_FAIL,
  payload: error,
})

export const addNewCarPark = CarPark => ({
  type: ADD_NEW_CARPARK,
  payload: CarPark,
})

export const addCarParkSuccess = CarPark => ({
  type: ADD_CARPARK_SUCCESS,
  payload: CarPark,
})

export const addCarParkFail = error => ({
  type: ADD_CARPARK_FAIL,
  payload: error,
})

export const updateCarPark = CarPark => ({
  type: UPDATE_CARPARK,
  payload: CarPark,
})

export const updateCarParkSuccess = CarPark => ({
  type: UPDATE_CARPARK_SUCCESS,
  payload: CarPark,
})

export const updateCarParkFail = error => ({
  type: UPDATE_CARPARK_FAIL,
  payload: error,
})

export const getCarParkDetail = CarParkId => ({
  type: GET_CARPARK_DETAIL,
  CarParkId,
})

export const getCarParkDetailSuccess = CarParkDetails => ({
  type: GET_CARPARK_DETAIL_SUCCESS,
  payload: CarParkDetails,
})

export const getCarParkDetailFail = error => ({
  type: GET_CARPARK_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
export const deleteCarPark = CarPark => ({
  type: DELETE_CARPARK,
  payload: CarPark,
})

export const deleteCarParkSuccess = CarPark => ({
  type: DELETE_CARPARK_SUCCESS,
  payload: CarPark,
})

export const deleteCarParkFail = error => ({
  type: DELETE_CARPARK_FAIL,
  payload: error,
})


export const getExportOccupancyRate = payload => ({
  type: GET_EXPORT_OCCUPANCY_RATE,
  payload,
})

export const getExportOccupancyRateSuccess = OccupancyRate => ({
  type: GET_EXPORT_OCCUPANCY_RATE_SUCCESS,
  payload: OccupancyRate,
})

export const getExportOccupancyRateFail = error => ({
  type: GET_EXPORTED_OCCUPANCY_RATE_FAIL,
  payload: error,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})
